import axios from "axios";

export const fetchParentCompanyLookup = async () => {
  return await axios.get("/api/company/parent-company-lookup");
};
